<template>
  <el-dialog :visible="true" @close="$emit('close')">
    <div class="text-center">
      <p class="text-black text-lg">请用手机微信扫描下方二维码分享</p>
      <p class="text-red text-medium" v-if="isTest">(测试答题，不真实发放红包)</p>
      <p class="mt-3 text-small">
        <i class="el-icon-warning-outline text-theme"></i>
        直接分享该二维码，将无法获得分享奖励
      </p>
      <div>
        <vue-qr v-if="!isTest" :text="url" />
        <img v-else src="/img/wechat.jpg" width="200" />
      </div>
      <ul class="p-0 px-5 leading-9 inline-block m-auto mt-8">
        <li class="text-black">分享领红包方法：</li>
        <li>1.用手机微信扫码打开问卷；</li>
        <li>2.点击右上角【...】分享答卷给好友或发布到朋友圈；</li>
        <li>3.好友答卷并符合要求，系统会将奖励自动发放到您的“调研工厂+”公众号中。</li>
      </ul>
    </div>
  </el-dialog>
</template>

<script>
import VueQr from 'vue-qr'

export default {
  name: 'SharePopup',
  components: { VueQr },
  props: {
    isTest: {
      type: Boolean,
      default: false
    },
    url: {
      type: String,
      required: true
    }
  }
}
</script>
